import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import 'angular2-notifications';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'iconify-icon';
import '@angular/compiler';
// AG Grid license + module registration live in
// `src/app/helpers/ag-grid/ag-grid-modules.ts`, imported by each lazy grid
// feature module — not here — so AG Grid Enterprise stays out of the login bundle.

if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function () { };
    window.console.warn = function () { };
    window.console.error = function () { };
    window.console.time = function () { };
    window.console.timeEnd = function () { };
  }
}

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
